import { LoadingState } from "../LoadingState";

export interface RequestState {
  loadingState: LoadingState;
  activeRequestId?: string;
  loadingStateBeforeRequest?: LoadingState;
  error?: string;
  errorBeforeRequest?: string;
}

export function beginRequest(state: RequestState, requestId: string) {
  if (state.loadingState !== LoadingState.Pending) {
    state.loadingStateBeforeRequest = state.loadingState;
    state.errorBeforeRequest = state.error;
  }
  state.activeRequestId = requestId;
  state.loadingState = LoadingState.Pending;
  state.error = undefined;
}

export function completeRequest(state: RequestState, requestId: string): boolean {
  if (state.activeRequestId !== requestId) {
    return false;
  }
  state.loadingState = LoadingState.Complete;
  state.error = undefined;
  clearOwnership(state);
  return true;
}

export function rejectRequest(
  state: RequestState,
  action: {
    meta: { requestId: string; aborted?: boolean };
    error: { name?: string; code?: string; message?: string };
  }
): boolean {
  if (state.activeRequestId !== action.meta.requestId) {
    return false;
  }
  const cancelled =
    action.meta.aborted || action.error.name === "AbortError" || action.error.code === "ERR_CANCELED";
  state.loadingState = cancelled
    ? (state.loadingStateBeforeRequest ?? LoadingState.None)
    : LoadingState.Error;
  state.error = cancelled ? state.errorBeforeRequest : (action.error.message ?? "Request failed");
  clearOwnership(state);
  return true;
}

function clearOwnership(state: RequestState) {
  delete state.activeRequestId;
  delete state.loadingStateBeforeRequest;
  delete state.errorBeforeRequest;
}
